import styled from 'styled-components';
import { Dialog } from '@material-ui/core';

export const StyledDialog = styled(Dialog)`
  & > * > .MuiDialog-paper {
    min-height: 300px;
  }
`;
